import { VariantProps, cva } from 'class-variance-authority';

export const statusIconStyles = cva(['min-w-8 w-8 h-8'], {
  variants: {
    variant: {
      circular: ['rounded-full'],
      square: [''],
    },
    color: {
      default: ['bg-primaryMain'],
      success: ['bg-success300'],
      error: ['bg-error300'],
      warning: ['bg-warning300'],
      info: ['bg-info300'],
      inactive: ['bg-grayscale400'],
    },
  },
});

export type StatusIconStylesVariants = VariantProps<typeof statusIconStyles>;
